import React from 'react';
import { SectionShell } from './SectionShell';
import { collaborators } from '../data/caseStudy';
export function Collaborators() {
  return <SectionShell number="06" title="Who I worked with" tone="dark" eyebrow="Four groups, each needing something different from the same brand system." data-id="element-27" data-mp="1l8l7i253d9xu">
      <div className="grid grid-cols-2 gap-px bg-white/15" data-id="element-28" data-mp="1uywmcjqbd3ji">
        {collaborators.map(group => <article key={group.title} className="bg-ink p-12" data-id="element-29" data-mp="1zwodvcn1qnn6">
            <h3 className="font-display text-2xl font-semibold tracking-tightest text-white" data-id="element-30" data-mp="23y9wzfq6by5t">{group.title}</h3>
            <div className="mt-5 h-[3px] w-12 accent-rule" aria-hidden="true" data-id="element-31" data-mp="28xml03ss7b9z" />
            <p className="mt-6 text-[15px] leading-relaxed text-white/75" data-id="element-32" data-mp="2dwqruns8gwx5">{group.body}</p>
          </article>)}
      </div>
    </SectionShell>;
}